import React, { Component } from "react";
import BookingTestDrive from "./bookingTestDrive";

import "../css/bookingForms.less";

export default class BookingForms extends Component {
  render() {
    return (
      <>
        <BookingTestDrive
          gridSize={this.props.formGridSize}
          ClientId={this.props.ClientId}
          PixelID={this.props.PixelID}
          carDisplayName={this.props.carDisplayName}
          carDisplayNames={this.props.carDisplayNames}
          carDisplayNameForLead={this.props.carDisplayNameForLead}
          carDisplayNameForLeads={this.props.carDisplayNameForLeads}
          isHomePage={this.props.isHomePage}
          formId={this.props.formBookingId}
          carList={this.props.carList || []}
        />
      </>
    );
  }
}
